import { gql } from '@apollo/client';
const GET_GLOBAL_EXCHANGE_RATES = gql `
  query getGlobalExchangeRates($toCurrencyId: String) {
    autocomplete {
      globalExchangeRates(toCurrencyId: $toCurrencyId) {
        createdDate
        modifiedDate
        id
        currencyFrom {
          id
          name
          isoCode
        }
        currencyTo {
          id
          name
          isoCode
        }
        rate
      }
    }
  }
`;
export default GET_GLOBAL_EXCHANGE_RATES;
